<template>
  <div
    class="footer"
    :style="themeStyle"
  >
    <footer
      v-if="configData.useImageFooter"
      class="image-footer"
    >
      <div
        v-if="configData.background.image"
        class="footer-background-image"
      >
        <picture>
          <source
            :srcset="`${baseUrl}${webpImage(configData.background.image)}`"
            type="image/webp"
          >
          <b-img-lazy
            :src="`${baseUrl}${configData.background.image}`"
            :alt="configData.background.alt"
          />
        </picture>
      </div>
      <div
        v-else
        class="footer-default-img"
      >
        <picture>
          <source
            :srcset="require('@/assets/images/items/image.webp')"
            type="image/webp"
          >
          <b-img
            :src="require('@/assets/images/items/image.png')"
            alt="頁尾圖片"
            class="mb-1"
          />
        </picture>
      </div>
      <div
        v-if="configData.useSponsorImage"
        class="sponsor-img"
      >
        <a
          v-if="configData.sponsor.url"
          :href="configData.sponsor.url"
        >
          <div v-if="configData.sponsor.image">
            <picture>
              <source
                :srcset="`${baseUrl}${webpImage(configData.sponsor.image)}`"
                type="image/webp"
              >
              <b-img-lazy
                :src="`${baseUrl}${configData.sponsor.image}`"
                :alt="configData.sponsor.alt"
              />
            </picture>
          </div>
          <div
            v-else
            class="sponsor-default-img"
          >
            <picture>
              <source
                :srcset="require('@/assets/images/items/image.webp')"
                type="image/webp"
              >
              <b-img
                :src="require('@/assets/images/items/image.png')"
                :alt="configData.sponsor.alt"
              />
            </picture>
          </div>
        </a>
        <div v-else>
          <div v-if="configData.sponsor.image">
            <picture>
              <source
                :srcset="`${baseUrl}${webpImage(configData.sponsor.image)}`"
                type="image/webp"
              >
              <b-img-lazy
                :src="`${baseUrl}${configData.sponsor.image}`"
                :alt="configData.sponsor.alt"
              />
            </picture>
          </div>
          <div
            v-else
            class="sponsor-default-img"
          >
            <picture>
              <source
                :srcset="require('@/assets/images/items/image.webp')"
                type="image/webp"
              >
              <b-img
                :src="require('@/assets/images/items/image.png')"
                :alt="configData.sponsor.alt"
              />
            </picture>
          </div>
        </div>
      </div>

      <div
        v-if="adData && adData.isFree && adData.advertise.image"
        class="support-img container"
      >
        <a
          v-if="adData.advertise.url"
          :href="adData.advertise.url"
        >
          <vue-load-image>
            <b-img
              slot="image"
              :src="adData.advertise.image"
              :alt="adData.advertise.alt"
              fluid-grow
              width="500"
            />
            <b-img
              slot="preloader"
              :src="require('@/assets/images/items/loading-2.png')"
              rounded
              height="60"
              width="60"
            />
            <b-img
              slot="error"
              :src="require('@/assets/images/items/image.png')"
              rounded
              height="120"
              width="120"
            />
          </vue-load-image>
        </a>
        <div
          v-else
        >
          <vue-load-image>
            <b-img
              slot="image"
              :src="adData.advertise.image"
              :alt="adData.advertise.alt"
              fluid-grow
              width="500"
            />
            <b-img
              slot="preloader"
              :src="require('@/assets/images/items/loading-2.png')"
              rounded
              height="60"
              width="60"
            />
            <b-img
              slot="error"
              :src="require('@/assets/images/items/image.png')"
              rounded
              height="120"
              width="120"
            />
          </vue-load-image>
        </div>
      </div>
    </footer>
    <footer
      v-else
      class="footer-dark"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-6 item">

            <div class="row">
              <div
                v-if="configData.logo && configData.logo.image"
                class="d-flex justify-content-center justify-content-md-start"
                :class="configData.textLeft && configData.textLeft.length > 0 ? 'col-lg-3' : 'col-lg-12'"
              >
                <a
                  v-if="configData.logo.url"
                  :href="configData.logo.url"
                >
                  <picture>
                    <source
                      :srcset="`${baseUrl}${webpImage(configData.logo.image)}`"
                      type="image/webp"
                    >
                    <b-img-lazy
                      :src="`${baseUrl}${configData.logo.image}`"
                      :alt="configData.logo.alt"
                      class="footer-image"
                      fluid
                    />
                  </picture>
                </a>
                <div v-else>
                  <picture>
                    <source
                      :srcset="`${baseUrl}${webpImage(configData.logo.image)}`"
                      type="image/webp"
                    >
                    <b-img-lazy
                      :src="`${baseUrl}${configData.logo.image}`"
                      :alt="configData.logo.alt"
                      class="footer-image"
                      fluid
                    />
                  </picture>
                </div>
              </div>
              <div
                v-if="configData.textLeft && configData.textLeft.length > 0"
                :class="configData.logo && configData.logo.image ? 'col-lg-9' : 'col-lg-12'"
              >
                <div class="row">
                  <div class="col-lg-12">
                    <p
                      v-for="txt, index in configData.textLeft"
                      :key="index"
                    >
                      <span v-if="!txt.label">
                        <br>
                      </span>
                      <span v-else>
                        {{ txt.label }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 item">
            <div class="row">
              <div
                v-if="configData.img && configData.img.image"
                class="d-flex justify-content-center justify-content-lg-start justify-content-lg-end"
                :class="configData.textRight && configData.textRight.length > 0 ? 'col-lg-3' : 'col-lg-12'"
              >
                <a
                  v-if="configData.img.url"
                  :href="configData.img.url"
                >
                  <picture>
                    <source
                      :srcset="`${baseUrl}${webpImage(configData.img.image)}`"
                      type="image/webp"
                    >
                    <b-img-lazy
                      :src="`${baseUrl}${configData.img.image}`"
                      :alt="configData.img.alt"
                      class="footer-image"
                      fluid
                    />
                  </picture>
                </a>
                <div v-else>
                  <picture>
                    <source
                      :srcset="`${baseUrl}${webpImage(configData.img.image)}`"
                      type="image/webp"
                    >
                    <b-img-lazy
                      :src="`${baseUrl}${configData.img.image}`"
                      :alt="configData.img.alt"
                      class="footer-image"
                      fluid
                    />
                  </picture>
                </div>
              </div>
              <div
                v-if="configData.textRight && configData.textRight.length > 0"
                :class="configData.img && configData.img.image ? 'col-lg-9' : 'col-lg-12'"
              >
                <div class="row">
                  <div class="col-lg-12">
                    <p
                      v-for="txt, index in configData.textRight"
                      :key="index"
                    >
                      <span v-if="!txt.label">
                        <br>
                      </span>
                      <span v-else>
                        {{ txt.label }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div
              v-if="configData.useSponsorImage"
              class="sponsor-img"
            >
              <a
                v-if="configData.sponsor.url"
                :href="configData.sponsor.url"
              >
                <picture v-if="configData.sponsor.image">
                  <source
                    :srcset="`${baseUrl}${webpImage(configData.sponsor.image)}`"
                    type="image/webp"
                  >
                  <b-img-lazy
                    :src="`${baseUrl}${configData.sponsor.image}`"
                    :alt="configData.sponsor.alt"
                  />
                </picture>
              </a>
              <div v-else>
                <picture v-if="configData.sponsor.image">
                  <source
                    :srcset="`${baseUrl}${webpImage(configData.sponsor.image)}`"
                    type="image/webp"
                  >
                  <b-img-lazy
                    :src="`${baseUrl}${configData.sponsor.image}`"
                    :alt="configData.sponsor.alt"
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="adData && adData.isFree && adData.advertise.image"
        class="support-img container"
      >
        <a :href="adData.advertise.url">
          <vue-load-image>
            <b-img
              slot="image"
              :src="adData.advertise.image"
              :alt="adData.advertise.alt"
              fluid-grow
              width="500"
            />
            <b-img
              slot="preloader"
              :src="require('@/assets/images/items/loading-2.png')"
              rounded
              height="60"
              width="60"
            />
            <b-img
              slot="error"
              :src="require('@/assets/images/items/image.png')"
              rounded
              height="120"
              width="120"
            />
          </vue-load-image>
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import { BImgLazy, BImg } from 'bootstrap-vue'
import VueLoadImage from 'vue-load-image'

export default {
  components: {
    BImgLazy,
    BImg,
    VueLoadImage,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
    adData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
    footerCheck() {
      return this.configData.img.image
        || this.configData.logo.image
        || this.configData.sponsor.image
        || this.configData.textLeft.length > 0
        || this.configData.textRight.length > 0
    },
  },
  mounted() {
    this.themeStyle = [
      this.configData.config,
      { zIndex: this.configData.useFooterFront ? 10 : 1 },
    ]
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      return webpSrc
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 10vh;
  bottom: 0;
  width: 100%;
}
footer {
  position: relative;
  z-index: 10;
  margin-top: calc(var(--footer-margin) * -1vw);
}
.footer-dark {
  flex: 1;
  margin-top: 0;
  padding: 30px 0 10px 0;
  color:var(--text-color);
  background-color: var(--background-color);
  .support-img {
    display: flex;
    justify-content: flex-end;
    @media screen and (max-width: 991px) {
      justify-content: center;
    }
  }
}
.footer-background-image {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img {
    width: 100%;
  }
  @media screen and (max-width:767px) {
    img {
      width: 100vh;
    }
  }
}
.footer-default-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  height: 100%;
  border: 2px dashed #dfdfdf;
  border-radius: 10px;
  img {
    max-width: 200px;
  }
}
.sponsor-default-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  height: 100%;
  border: 2px dashed #dfdfdf;
  border-radius: 10px;
  background: #000;
  img {
    width: 100px;
    height: 100px;
  }
}
.image-footer {
  .support-img {
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: flex-end;
    @media screen and (max-width: 991px) {
      justify-content: center;
    }
  }
  .sponsor-img {
    position: absolute;
    top: 0%;
    @media screen and (max-width: 991px) {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.sponsor-img img{
  max-width: 100%;
}

.support-img img{
  max-width: 500px;
  max-height: 70px;
}
.footer-dark {
  .item {
    p {
      margin-bottom:0;
    }
    @media screen and (max-width: 991px) {
      align-self: flex-end;
    }
    @media screen and (max-width: 767px) {
      text-align:center;
      padding-bottom:20px;
    }
  }
}
.footer-dark .copyright {
  text-align:center;
  padding-top:12px;
  font-size:13px;
  margin-bottom:0;
}
.goTop {
  position: fixed;
  z-index: 1000;
  bottom: 5%;
  right: 5%;
  cursor: pointer;
}

@media screen and (max-width:991px) {
  .footer-image {
    max-height: 20vh;
    margin-bottom: 12px;
  }
}
</style>
